import { $, $$ } from '../_utils'

class FormInfo {
  constructor($trigger) {
    this.$trigger = $trigger
    this.$parent = $trigger.parentNode
    this.$formInfo = $('.form-info', this.$parent)
    this.$closeButton = $('.js-form-info-close', this.$formInfo)
  }

  addClickListener = () => {
    this.$trigger.addEventListener('click', this.handleClick)
  }

  handleClick = () => {
    this.$formInfo.classList.toggle('showInfo')
  }
  handleClose = () => {
    if (this.$closeButton) {
      this.$closeButton.addEventListener('click', () => {
        this.$formInfo.classList.remove('showInfo')
      })
    }
  }

  init = () => {
    this.addClickListener()
    this.handleClose()
  }
}

window.addEventListener('load', () => {
  const $$triggers = $$('.js-form-info-trigger')
  $$triggers.forEach($trigger => {
    const formTrigger = new FormInfo($trigger)
    formTrigger.init()
  })
})
